import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Location } from 'vue-router';
import { Moment } from 'moment';
import { EdgePatientEnrollmentApi, EdgeCouponApi } from '@trialcard/apigateway.client';
import { Gender } from '@trialcard/enums';
import { Resolve } from 'vue-di';
import { OnClear } from '~/services/clearModule';
import { clearRecords } from '~/services/clearRecords';
import { VUFile } from '~/types/componentTypes';

@InjectModule({ stateFactory: true }, module)
@OnClear<PatientModule>(async value => value.clear())
export default class PatientModule extends InjectVuexModule {
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;
    public edgeCoupon!: EdgeCouponApi;

    // @Action({})
    // public async patientSearch(programId: number, request: EnrollmentPatientSearchRequestModel) {
    //     let response: EnrollmentPatientSearchResultModelResponse;
    //     try {
    //         const patientSearchResponse = await this.edgeCoupon.patientPatientSearch({...request, programId});
    //         const patientSearchData = patientSearchResponse.data;
    //         this.searchResults = patientSearchData.data.results;
    //     } catch (error) {
    //         // log error
    //     }
    //     return response!;
    // }

    public demographicInformation = {
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: null as Moment | string | null,
        gender: null as Gender | null,
        addresses: [
            {
                addressOne: '',
                addressTwo: '',
                zip: '',
                city: '',
                state: '',
            },
        ],
        phoneNumbers: [
            {
                phoneType: 1,
                phonePurpose: 1,
                phoneNumber: '',
            },
        ],
    };

    public insuranceVerification = {
        insuranceType: 1,
        payerName: '',
        payerMedicalId: ''
    };

    public otherInformation = {
        daySupply: '',
        quantity: '',
        pharmacyType: '',
        remainingCost: '',
        totalCost: '',
        insuranceCoverage: '',
        prescriptionInsurance: null as null | boolean,
        productPurchased: '',
        submissionType: '',
    };

    @Mutation
    public clear() {
        clearRecords(this.demographicInformation);
    }

    @Mutation
    public updateDemographicInformation(data: typeof PatientModule.prototype.demographicInformation) {
        Object.assign(this.demographicInformation, data);
    }

    @Mutation
    public updateInsuranceVerification(data: typeof PatientModule.prototype.insuranceVerification) {
        Object.assign(this.insuranceVerification, data);
    }

    @Mutation
    public updateOtherInformation(data: typeof PatientModule.prototype.otherInformation) {
        Object.assign(this.otherInformation, data);
    }

    public files = [] as VUFile[];

    @Mutation
    public updateFiles(data: typeof PatientModule.prototype.files) {
        // Object.assign(this.files, data);
        this.files = data;
    }

    /*

    @Action({})
    public async submit() {
        try {
            await this.uploadDocument();
            const site = await this.createSite();
            const prescriber = await this.createPrescriber();
            await this.enrollPatient(site, prescriber);
        } catch {
            //error page
            return;
        }
        this.clear();
        return;
    }
    */

    // @Action({})
    // public async submit(): Promise<object | string> {
    //     const response = await this.patientEnrollmentApi.patientEnrollmentEnrollPatient({
    //         account: {
    //             accountData: {
    //                 canInsert: true,
    //                 canUpdate: true,
    //                 skipSearch: false,
    //                 model: {},
    //             },
    //         },
    //     });
    //     return {}; // dest route
    // }
}
